<script setup lang="ts">
import { useProfileStore } from '@/src/store/profile';
import useDateFormatter from '@/src/composables/useDateFormatter';
import SeIcon from '@/src/ui-kit/icon/Icon.vue';
import SeButton from '@/src/ui-kit/button/Button.vue';

const props = withDefaults(
  defineProps<{
    title: string;
    preQuestions: any;
    isEditable?: boolean;
    onlyQuestion?: boolean;
  }>(),
  {
    onlyQuestion: false,
    isEditable: false,
  }
);

const profile = useProfileStore();
const { setPreQuestionsPopupVisible } = profile;
</script>

<script lang="ts">
export default {
  name: 'SePreQuestionsCard',
};
</script>

<template>
  <div>
    <div class="flex justify-between items-center mb-8">
      <p class="text-h-l font-bold">{{ props.title }}</p>
      <se-button
        class="flex items-center gap-[6px]"
        type="secondary"
        size="small"
        @click="setPreQuestionsPopupVisible(true)"
      >
        <se-icon name="pencil-line"></se-icon>Edit
      </se-button>
    </div>
    <div v-if="!onlyQuestion" class="text-b-s text-neutral-80">
      <p>Name: {{ preQuestions?.full_name }}</p>
      <p>
        Date of birth:
        {{
          preQuestions?.date_of_birth ? useDateFormatter().formatDate(preQuestions?.date_of_birth, 'MM/dd/yyyy') : ''
        }}
      </p>
      <p>Gender: {{ preQuestions?.gender }}</p>
      <p class="font-semibold">Your question: {{ preQuestions?.question }}</p>
      <p>Other person's name: {{ preQuestions?.other_person_name }}</p>
      <p>
        Other person's date of birth:
        {{
          preQuestions?.other_person_date_of_birth
            ? useDateFormatter().formatDate(preQuestions?.other_person_date_of_birth, 'MM/dd/yyyy')
            : ''
        }}
      </p>
    </div>
    <p v-else class="text-neutral-80 font-b-s">{{ preQuestions?.question ? preQuestions?.question : '--' }}</p>
  </div>
</template>

<style scoped lang="scss"></style>
